import SvgFlipBackward from '@bazaar-marketplace/assets/flip-backward';

interface SheetBackButtonProps {
  onClick: () => void;
}

export function SheetBackButton(props: SheetBackButtonProps) {
  return (
    <div
      className="absolute top-[24px] left-[24px] rounded-xl transition-opacity hover:opacity-90 disabled:pointer-events-none size-[42px] shrink-0"
      onClick={() => {
        props.onClick();
      }}
    >
      <div className="flex items-center justify-center p-3 bg-white/10 backdrop-blur-[25px] border border-white/20 rounded-2xl">
        <SvgFlipBackward />
      </div>
    </div>
  );
}
